/* ============================================================
   ÉVINEL × CUSTOM REVIEWS WIDGET — VERSION FINALE
   Fichier : assets/evinel-reviews.js
   ============================================================ */

(function() {
  'use strict';

  const PROXY_URL = 'https://evinel-judgeme-proxy.u5029741791.workers.dev';

  let initialized = false;

  function initWidget() {
    if (initialized) return;
    const root = document.getElementById('evinel-reviews-root');
    if (!root) return;
    initialized = true;

    const productId = root.dataset.productId;
    const productHandle = root.dataset.productHandle;
    const productTitle = root.dataset.productTitle;

    fetchReviews(productId, root, { productHandle, productTitle });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWidget);
  } else {
    initWidget();
  }

  async function fetchReviews(productId, root, ctx) {
    try {
      // Récupère la première page
      const firstRes = await fetch(`${PROXY_URL}/reviews?product_id=${productId}&page=1`);
      const firstData = await firstRes.json();
      
      if (firstData.error) {
        renderEmpty(root, ctx);
        return;
      }

      let allReviews = firstData.reviews || [];
      const totalPages = firstData.total_pages || 1;

      // Si plusieurs pages, récupère les suivantes en parallèle (max 10 pages = ~1000 avis)
      if (totalPages > 1) {
        const maxPages = Math.min(totalPages, 10);
        const promises = [];
        for (let p = 2; p <= maxPages; p++) {
          promises.push(
            fetch(`${PROXY_URL}/reviews?product_id=${productId}&page=${p}`)
              .then(r => r.json())
              .then(d => d.reviews || [])
              .catch(() => [])
          );
        }
        const otherPages = await Promise.all(promises);
        otherPages.forEach(reviews => {
          allReviews = allReviews.concat(reviews);
        });
      }

      renderWidget(root, allReviews, ctx, firstData);
    } catch (err) {
      console.error('[Evinel Reviews]', err);
      renderEmpty(root, ctx);
    }
  }

  function renderWidget(root, reviews, ctx, apiData) {
    const stats = computeStats(reviews);
    const state = {
      reviews,
      filtered: reviews,
      filter: 'all',
      sort: 'recent',
      visibleCount: 6,
      ctx,
      stats,
    };

    root.innerHTML = `
      <div class="evinel-reviews__container">
        ${renderHeader(stats)}
        ${renderSummary(stats)}
        ${renderFilters(stats)}
        <div class="evinel-reviews__list" id="evinel-reviews-list"></div>
        <div class="evinel-reviews__actions">
          <button class="evinel-reviews__btn evinel-reviews__btn--secondary" id="evinel-load-more">
            Voir plus d'avis
          </button>
          <button class="evinel-reviews__btn evinel-reviews__btn--primary" id="evinel-write-review">
            Écrire un avis
          </button>
        </div>
      </div>
    `;

    bindEvents(root, state);
    applyFilters(state);
    renderList(root, state);
  }

  function renderHeader(stats) {
    return '';
  }

  function renderSummary(stats) {
    const histogram = [5, 4, 3, 2, 1].map(n => {
      const count = stats.distribution[n] || 0;
      const pct = stats.total ? (count / stats.total * 100) : 0;
      return `
        <div class="evinel-reviews__histo-row">
          <span class="evinel-reviews__histo-label">${n} ★</span>
          <div class="evinel-reviews__histo-bar">
            <div class="evinel-reviews__histo-fill" style="width: ${pct}%"></div>
          </div>
          <span class="evinel-reviews__histo-count">${count}</span>
        </div>
      `;
    }).join('');

    return `
      <div class="evinel-reviews__summary">
        <div class="evinel-reviews__summary-left">
          <h2 class="evinel-reviews__title">Avis clients</h2>
          <p class="evinel-reviews__subtitle">CE QUE LES PARENTS DISENT</p>
          <div class="evinel-reviews__summary-rating">
            <div class="evinel-reviews__summary-avg">${stats.average.toFixed(1).replace('.', ',')}</div>
            <div class="evinel-reviews__summary-rating-right">
              <div class="evinel-reviews__summary-stars">${renderStars(stats.average)}</div>
              <p class="evinel-reviews__summary-count">${stats.total} avis vérifiés</p>
            </div>
          </div>
        </div>
        <div class="evinel-reviews__summary-right">
          ${histogram}
        </div>
      </div>
    `;
  }

  function renderFilters(stats) {
    return `
      <div class="evinel-reviews__filters">
        <div class="evinel-reviews__filter-pills">
          <button class="evinel-reviews__pill is-active" data-filter="all">Tous (${stats.total})</button>
          <button class="evinel-reviews__pill" data-filter="5">5 ★</button>
          <button class="evinel-reviews__pill" data-filter="4">4 ★</button>
          <button class="evinel-reviews__pill" data-filter="photos">Avec photos</button>
        </div>
        <div class="evinel-reviews__sort">
          <select id="evinel-sort">
            <option value="recent">Plus récents</option>
            <option value="rating-high">Note la plus haute</option>
            <option value="rating-low">Note la plus basse</option>
          </select>
        </div>
      </div>
    `;
  }

  function renderList(root, state) {
    const list = root.querySelector('#evinel-reviews-list');
    const visible = state.filtered.slice(0, state.visibleCount);

    if (visible.length === 0) {
      list.innerHTML = `<p class="evinel-reviews__empty">Aucun avis ne correspond à ce filtre.</p>`;
    } else {
      list.innerHTML = visible.map(renderReviewCard).join('');
    }

    const btn = root.querySelector('#evinel-load-more');
    if (btn) {
      if (state.filtered.length > state.visibleCount) {
        btn.style.display = '';
      } else {
        btn.style.display = 'none';
      }
    }
  }

  function renderReviewCard(review) {
    const initials = getInitials(review.reviewer_name || 'Anonyme');
    const date = formatRelativeDate(review.created_at);
    const verified = `<span class="evinel-reviews__verified">✓ Vérifié</span>`;
    const body = stripHtml(review.body || review.body_html || '').trim();
    const title = (review.title || '').trim();
    const photos = (review.pictures_urls || []).filter(Boolean);
    const photosHtml = photos.length > 0
      ? `<div class="evinel-reviews__photos">${photos.slice(0, 4).map(url => 
          `<img src="${url}" loading="lazy" alt="Photo client">`
        ).join('')}</div>`
      : '';

    return `
      <article class="evinel-review">
        <div class="evinel-review__head">
          <div class="evinel-review__avatar">${initials}</div>
          <div class="evinel-review__meta">
            <div class="evinel-review__name">${escapeHtml(review.reviewer_name || 'Anonyme')}</div>
            <div class="evinel-review__date">${date} ${verified}</div>
          </div>
        </div>
        <div class="evinel-review__rating">${renderStars(review.rating)}</div>
        ${title ? `<h3 class="evinel-review__title">${escapeHtml(title)}</h3>` : ''}
        <p class="evinel-review__body">${escapeHtml(body)}</p>
        ${photosHtml}
      </article>
    `;
  }

  function bindEvents(root, state) {
    root.querySelectorAll('.evinel-reviews__pill').forEach(pill => {
      pill.addEventListener('click', () => {
        root.querySelectorAll('.evinel-reviews__pill').forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        state.filter = pill.dataset.filter;
        applyFilters(state);
        state.visibleCount = 6;
        renderList(root, state);
      });
    });

    const sortSelect = root.querySelector('#evinel-sort');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        state.sort = sortSelect.value;
        applyFilters(state);
        renderList(root, state);
      });
    }

    const loadMoreBtn = root.querySelector('#evinel-load-more');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        state.visibleCount += 6;
        renderList(root, state);
      });
    }

    const writeBtn = root.querySelector('#evinel-write-review');
    if (writeBtn) {
      writeBtn.addEventListener('click', () => {
        openModal(state);
      });
    }
  }

  function applyFilters(state) {
    let list = [...state.reviews];

    if (state.filter === '5') list = list.filter(r => r.rating === 5);
    else if (state.filter === '4') list = list.filter(r => r.rating === 4);
    else if (state.filter === 'photos') list = list.filter(r => (r.pictures_urls || []).length > 0);

    if (state.sort === 'recent') {
      list.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    } else if (state.sort === 'rating-high') {
      list.sort((a, b) => b.rating - a.rating);
    } else if (state.sort === 'rating-low') {
      list.sort((a, b) => a.rating - b.rating);
    }

    state.filtered = list;
  }

  function openModal(state) {
    const modal = document.createElement('div');
    modal.className = 'evinel-modal';
    modal.innerHTML = `
      <div class="evinel-modal__backdrop"></div>
      <div class="evinel-modal__content">
        <button class="evinel-modal__close" aria-label="Fermer">×</button>
        <h2 class="evinel-modal__title">Écrire un avis</h2>
        <p class="evinel-modal__subtitle">Sur ${escapeHtml(state.ctx.productTitle)}</p>
        <form id="evinel-review-form" class="evinel-form">
          <div class="evinel-form__field">
            <label>Votre note</label>
            <div class="evinel-form__stars">
              ${[1,2,3,4,5].map(n => `<button type="button" data-star="${n}" class="evinel-form__star">★</button>`).join('')}
            </div>
            <input type="hidden" name="rating" id="evinel-form-rating" value="5">
          </div>
          <div class="evinel-form__field">
            <label>Votre prénom</label>
            <input type="text" name="reviewer_name" required>
          </div>
          <div class="evinel-form__field">
            <label>Votre email</label>
            <input type="email" name="email" required>
          </div>
          <div class="evinel-form__field">
            <label>Titre de votre avis</label>
            <input type="text" name="title" required>
          </div>
          <div class="evinel-form__field">
            <label>Votre avis</label>
            <textarea name="body" rows="4" required></textarea>
          </div>
          <button type="submit" class="evinel-reviews__btn evinel-reviews__btn--primary evinel-form__submit">
            Publier mon avis
          </button>
        </form>
        <div class="evinel-form__success" style="display:none;">
          <p>✓ Merci ! Votre avis a bien été envoyé. Il sera publié après modération.</p>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    const stars = modal.querySelectorAll('.evinel-form__star');
    let currentRating = 5;
    updateStars(stars, currentRating);
    stars.forEach(s => {
      s.addEventListener('click', () => {
        currentRating = parseInt(s.dataset.star);
        document.getElementById('evinel-form-rating').value = currentRating;
        updateStars(stars, currentRating);
      });
    });

    const close = () => {
      document.body.style.overflow = '';
      modal.remove();
    };
    modal.querySelector('.evinel-modal__close').addEventListener('click', close);
    modal.querySelector('.evinel-modal__backdrop').addEventListener('click', close);

    modal.querySelector('#evinel-review-form').addEventListener('submit', async (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      formData.append('id', state.ctx.productHandle);
      formData.append('platform', 'shopify');
      
      const submitBtn = form.querySelector('.evinel-form__submit');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Envoi...';

      try {
        await fetch(`${PROXY_URL}/submit`, {
          method: 'POST',
          body: formData,
        });
        form.style.display = 'none';
        modal.querySelector('.evinel-form__success').style.display = 'block';
        setTimeout(close, 3000);
      } catch (err) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Publier mon avis';
        alert('Erreur lors de l\'envoi. Réessayez.');
      }
    });
  }

  function updateStars(stars, rating) {
    stars.forEach((s, i) => {
      s.classList.toggle('is-active', i < rating);
    });
  }

  function renderEmpty(root, ctx) {
    root.innerHTML = `
      <div class="evinel-reviews__container">
        <h2 class="evinel-reviews__title">Avis clients</h2>
        <p class="evinel-reviews__empty">Soyez le premier à donner votre avis sur ${escapeHtml(ctx.productTitle)}.</p>
      </div>
    `;
  }

  function computeStats(reviews) {
    const total = reviews.length;
    const distribution = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    let sum = 0;
    reviews.forEach(r => {
      const rating = parseInt(r.rating) || 0;
      if (rating >= 1 && rating <= 5) {
        distribution[rating] = (distribution[rating] || 0) + 1;
        sum += rating;
      }
    });
    const average = total > 0 ? sum / total : 0;
    return { total, average, distribution };
  }

  function renderStars(rating) {
    const r = Math.round(parseFloat(rating) || 0);
    const starSvg = `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2.5c.4 0 .77.23.93.59l2.4 5.36 5.83.6c.4.04.74.31.86.69.13.38.02.8-.27 1.07l-4.36 4 1.21 5.74c.08.4-.07.8-.4 1.04-.32.23-.76.27-1.12.08L12 18.85l-5.08 2.84c-.36.2-.8.16-1.13-.07-.32-.24-.48-.65-.4-1.04l1.22-5.75-4.36-3.99c-.3-.27-.4-.7-.27-1.08.13-.37.46-.64.86-.68l5.83-.6 2.4-5.37A1.02 1.02 0 0 1 12 2.5z"/>
    </svg>`;
    
    let html = '';
    for (let i = 1; i <= 5; i++) {
      html += `<span class="evinel-star ${i <= r ? 'is-on' : ''}">${starSvg}</span>`;
    }
    return html;
  }
  function getInitials(name) {
    if (!name) return 'A';
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.slice(0, 2).toUpperCase();
  }

  function formatRelativeDate(dateStr) {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diff = now - date;
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    
    if (days < 1) return 'Aujourd\'hui';
    if (days === 1) return 'Hier';
    if (days < 7) return `Il y a ${days} jours`;
    if (days < 14) return 'Il y a 1 semaine';
    if (days < 30) return `Il y a ${Math.floor(days / 7)} semaines`;
    if (days < 60) return 'Il y a 1 mois';
    if (days < 365) return `Il y a ${Math.floor(days / 30)} mois`;
    return `Il y a ${Math.floor(days / 365)} an${Math.floor(days / 365) > 1 ? 's' : ''}`;
  }

  function stripHtml(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

})();